import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M18 7V6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1h2.954a1 1 0 0 1 .999 1.045L29.5 18l.434 6.938A1 1 0 0 1 28.936 26H18.863l-.357-5 .413-5.786A3 3 0 0 0 15.926 12h-1.698l-.18-3.955A1 1 0 0 1 15.047 7H18zm2-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4V6z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="m16.51 21.142.414 5.787A1 1 0 0 1 15.926 28H3.074a1 1 0 0 1-.997-1.071l.413-5.787c.007-.094.007-.19 0-.284l-.413-5.787A1 1 0 0 1 3.074 14H6v-1a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v1h2.926a1 1 0 0 1 .998 1.071l-.413 5.787c-.007.094-.007.19 0 .284zM11 14v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1h3z" clip-rule="evenodd"></path></g>';
export var ShoppingBagsSVG = function ShoppingBagsSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ShoppingBagsSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ShoppingBagsSVG);